module.exports = function getResource(label, vars = []) {
    const resources = {
        thisCardHasExpired: 'This card is expired. Please update your card information.',
        defaultCreditCard: 'Default card',
        makeDefaultCreditCard: 'Set as my default card',
        edit: 'Edit',
        addCreditCard: 'Add credit or debit card',
        cardDescText: `${vars[0]} ending in ${vars[1]}`,
        cardExpirationText: `Expires ${vars[0]} ${vars[1]}`,
        debitCardDisclaimer: 'Visa and Mastercard debit cards only',
        gotIt: 'Got It'
    };
    return resources[label];
};
